module.exports = __webpack_public_path__ + "static/media/18.011.02826ffe.webp";